export default __webpack_public_path__ + "static/media/andyTurnip.ff3377e0.jpg";